(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  /* ----- Galería mobile (slider scroll-snap) ----- */
  function initGalleryMobile() {
    var galleries = $$('[data-gallery-mobile]');
    galleries.forEach(function (gal) {
      var track = $('[data-gallery-track]', gal);
      var dots  = $$('[data-gallery-dot]', gal);
      var prev  = $('[data-gallery-prev]', gal);
      var next  = $('[data-gallery-next]', gal);
      var slides = $$('[data-gallery-slide]', track);
      if (!track || slides.length === 0) return;

      function setActive(idx) {
        dots.forEach(function (d) { d.classList.toggle('is-active', parseInt(d.dataset.index, 10) === idx); });
      }

      track.addEventListener('scroll', function () {
        var w = track.clientWidth;
        var idx = Math.round(track.scrollLeft / (slides[0].offsetWidth + 8));
        setActive(idx);
      }, { passive: true });

      function go(idx) {
        idx = Math.max(0, Math.min(slides.length - 1, idx));
        var target = slides[idx];
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActive(idx);
      }

      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(parseInt(d.dataset.index, 10)); });
      });
      if (prev) prev.addEventListener('click', function () {
        var current = Math.round(track.scrollLeft / (slides[0].offsetWidth + 8));
        go(current - 1);
      });
      if (next) next.addEventListener('click', function () {
        var current = Math.round(track.scrollLeft / (slides[0].offsetWidth + 8));
        go(current + 1);
      });
    });
  }

  /* ----- Selector de variantes (radios → variant id en select hidden) ----- */
  function initVariantSync() {
    var selectors = $$('[data-variant-selector]');
    selectors.forEach(function (selector) {
      var select = $('[data-variant-select]', selector);
      if (!select) return;
      var optionInputs = $$('input[type="radio"][name^="options["]', selector);
      if (optionInputs.length === 0) return;

      function syncVariant() {
        var optionValues = [];
        $$('fieldset[data-option-index]', selector).forEach(function (fs) {
          var checked = $('input[type="radio"]:checked', fs);
          optionValues.push(checked ? checked.value : null);
        });
        var match = $$('option', select).find(function (opt) {
          return opt.textContent.trim() === optionValues.join(' / ');
        });
        var variantChanged = false;
        if (match && select.value !== match.value) {
          select.value = match.value;
          variantChanged = true;
        }

        // Recalcular el precio de las tarjetas de opción 1 (Lleva 1/3/6) según las
        // OTRAS opciones seleccionadas (p. ej. Estuche). Debe ir ANTES de espejar
        // el precio principal, que lee del texto de la tarjeta marcada.
        updateRichCardPrices(selector);

        // Reflejar el precio de la variante seleccionada en el bloque de precio principal
        var section = selector.closest('.aceites-product') || document;
        var checkedRich = $('.aceites-product__option-value--rich input:checked', selector);
        if (checkedRich) {
          var card = checkedRich.parentElement.querySelector('.aceites-product__option-card');
          var priceEl = section.querySelector('.aceites-product__price');
          var compareEl = section.querySelector('.aceites-product__price-compare');
          var wrap = section.querySelector('.aceites-product__price-wrap');
          if (card && priceEl) {
            var newPrice = card.querySelector('.aceites-product__option-price');
            if (newPrice) priceEl.textContent = newPrice.textContent;
          }
          if (card && wrap) {
            var newCompare = card.querySelector('.aceites-product__option-price-compare');
            if (newCompare) {
              if (!compareEl) {
                compareEl = document.createElement('span');
                compareEl.className = 'aceites-product__price-compare';
                wrap.insertBefore(compareEl, wrap.firstChild);
              }
              compareEl.textContent = newCompare.textContent;
              compareEl.style.display = '';
            } else if (compareEl) {
              compareEl.style.display = 'none';
            }
          }
        }

        // Actualizar el mensaje de suscripción según el número de la variante
        // (primer "word" del option1, ej. "3 Botellas" → 3)
        updateSubscriptionMessage(section, checkedRich);

        if (variantChanged && match) {
          notifyVariantChange(section, select, match.value);
        }

        // Tras cambiar de variante, re-espejar el precio de suscripción (la app
        // actualiza su .in_widget_price al recibir el change; esperamos un frame).
        requestAnimationFrame(function () { mirrorSubscriptionPrice(section); });
      }
      optionInputs.forEach(function (i) { i.addEventListener('change', syncVariant); });

      // Ajuste inicial: si se entra con una opción no-default ya marcada (p. ej.
      // enlace directo a "Con estuche"), reflejar el precio correcto en las
      // tarjetas al cargar, sin disparar el resto de efectos de syncVariant.
      updateRichCardPrices(selector);
    });
  }

  /* ----- Actualiza el precio mostrado en las tarjetas de la 1ª opción
          (Lleva 1/3/6) según las demás opciones seleccionadas (Estuche, etc.).
          Sin esto las tarjetas quedan fijas al precio de la 1ª combinación y no
          reaccionan al cambiar "Sin estuche / Con estuche". Lee el mapa
          [data-variant-price-map] (precios ya formateados con | money). ----- */
  function updateRichCardPrices(selector) {
    var mapEl = $('[data-variant-price-map]', selector);
    if (!mapEl) return;
    var map;
    try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
    if (!map || !map.length) return;

    var selectedByIndex = $$('fieldset[data-option-index]', selector).map(function (fs) {
      var c = $('input[type="radio"]:checked', fs);
      return c ? c.value : null;
    });

    $$('.aceites-product__option-value--rich', selector).forEach(function (label) {
      var input = label.querySelector('input[type="radio"]');
      if (!input) return;
      var o1 = input.value;
      var match = map.find(function (v) {
        if (v.o1 !== o1) return false;
        if (v.o2 != null && selectedByIndex[1] != null && v.o2 !== selectedByIndex[1]) return false;
        if (v.o3 != null && selectedByIndex[2] != null && v.o3 !== selectedByIndex[2]) return false;
        return true;
      });
      if (!match) return;

      var priceEl = label.querySelector('.aceites-product__option-price');
      if (priceEl && match.price) priceEl.textContent = match.price;

      var prices = label.querySelector('.aceites-product__option-prices');
      var compareEl = label.querySelector('.aceites-product__option-price-compare');
      if (match.compare) {
        if (!compareEl && prices) {
          compareEl = document.createElement('span');
          compareEl.className = 'aceites-product__option-price-compare';
          prices.insertBefore(compareEl, prices.firstChild);
        }
        if (compareEl) { compareEl.textContent = match.compare; compareEl.style.display = ''; }
      } else if (compareEl) {
        compareEl.style.display = 'none';
      }
    });
  }

  /* ----- Actualiza .aceites-product__sub-message en función de la cantidad
          de la variante (parsea el primer número del value del radio). Usa
          plantillas data-text-singular / data-text-plural con {count}. ----- */
  function updateSubscriptionMessage(section, checkedRich) {
    var el = section.querySelector('[data-sub-message]');
    if (!el) return;
    var rawValue = checkedRich ? (checkedRich.value || '') : '';
    var firstWord = rawValue.split(' ')[0];
    var count = parseInt(firstWord, 10);
    if (!count || count < 1) count = 1;
    var tpl = count === 1
      ? el.getAttribute('data-text-singular')
      : el.getAttribute('data-text-plural');
    el.textContent = (tpl || '').replace('{count}', count);
    el.setAttribute('data-count', count);
  }

  /* ----- Notifica el cambio de variante a apps externas (Shopify Subscriptions) ----- */
  function notifyVariantChange(section, select, variantId) {
    // El cambio del radio burbujea solo hasta el <form data-variant-selector
    // action="/cart/add"> y dispara handleVariantChange del app block. No
    // hace falta re-dispatch en el <select>.

    // 1) Actualizar la URL — share / SEO y para que un reload mantenga la variante
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get('variant') !== String(variantId)) {
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      }
    } catch (e) { /* noop */ }

    // 2) Override de la visibilidad de las cards de Subscriptions. El app block
    //    tiene un bug: handleSellingPlanFormVisibility usa data-variant-id=
    //    (exact) cuando el getter visibleSellingPlanForm usa data-variant-id^=
    //    (starts-with). Si el server renderiza el id con sufijo (X_section),
    //    el exact match falla y la app esconde TODAS las cards. Lo hacemos
    //    nosotros con la misma lógica permisiva.
    //
    //    Timing: corremos PRIMERO de forma síncrona (deja la card correcta
    //    visible antes de que el app block, que va detrás en el bubble del
    //    change event sobre el form, esconda todo), y luego repetimos en rAF
    //    para corregir el estado tras el handler del app block. Esto evita
    //    tanto el frame oculto (causa del salto) como dejar la card escondida
    //    si el app block defiere su trabajo a un microtask propio.
    syncSubscriptionCards(section, variantId);
    requestAnimationFrame(function () {
      syncSubscriptionCards(section, variantId);
    });

    // 3) Custom event genérico por si algún bloque adicional lo escucha
    try {
      section.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true,
        detail: { variantId: variantId }
      }));
    } catch (e) { /* noop */ }
  }

  /* ----- Aplica visibilidad correcta a las cards del app block ----- */
  function syncSubscriptionCards(section, variantId) {
    var hiddenClass = 'shopify_subscriptions_app_block--hidden';
    var cards = section.querySelectorAll('.shopify_subscriptions_app_block[data-variant-id]');
    if (!cards.length) return;

    var vidStr = String(variantId);
    cards.forEach(function (card) {
      var cardVariantId = card.getAttribute('data-variant-id') || '';
      // Match exacto o con sufijo separado por "_" (formato VARIANT_SECTION).
      // Exigimos el "_" para evitar colisiones entre ids que comparten prefijo.
      var matches = cardVariantId === vidStr || cardVariantId.indexOf(vidStr + '_') === 0;
      if (matches) {
        card.classList.remove(hiddenClass);
      } else {
        card.classList.add(hiddenClass);
      }
    });
  }

  /* ----- Mapa de precios por variante/selling-plan, renderizado en Liquid
          (script[data-aceites-sp-prices]). Forma:
          { "<variantId>": { "base": "€11,95",
                             "<planId>": { "price": "€11,35", "savings": "€0,60" } } }
          Cada plan (frecuencia) tiene su propio descuento. ----- */
  var SP_PRICES;
  function getSpPrices() {
    if (SP_PRICES !== undefined) return SP_PRICES;
    SP_PRICES = {};
    try {
      var el = document.querySelector('script[data-aceites-sp-prices]');
      if (el) SP_PRICES = JSON.parse(el.textContent || '{}');
    } catch (e) { SP_PRICES = {}; }
    return SP_PRICES;
  }

  /* ----- Card de suscripción activa (la visible, sin la clase --hidden). ----- */
  function getActiveSubCard(section) {
    var cards = section.querySelectorAll('.shopify_subscriptions_app_block[data-variant-id]');
    if (!cards.length) return null;
    for (var i = 0; i < cards.length; i++) {
      if (!cards[i].classList.contains('shopify_subscriptions_app_block--hidden')) return cards[i];
    }
    var vs = section.querySelector('[data-variant-select]');
    var vid = vs ? String(vs.value) : null;
    if (vid) {
      for (var k = 0; k < cards.length; k++) {
        var cid = cards[k].getAttribute('data-variant-id') || '';
        if (cid === vid || cid.indexOf(vid + '_') === 0) return cards[k];
      }
    }
    return cards[0];
  }

  /* ----- Parseo de dinero en formato ES ("€11,95 EUR" → 11.95). ----- */
  function parseMoneyNum(str) {
    if (!str) return NaN;
    var s = String(str).replace(/[^0-9.,]/g, '');
    if (s.indexOf(',') > -1) s = s.replace(/\./g, '').replace(',', '.');
    return parseFloat(s);
  }

  // Ahorro mínimo (€) para mostrar el badge "Ahorra X€" (en 1 ud. es ~0,36€).
  var SAVINGS_MIN = 2;

  /* ----- Actualiza el precio mostrado (.in_widget_price del grupo elegido) y un
          badge "Ahorra X" según la frecuencia seleccionada. La fuente de verdad
          es el propio widget de la app:
            - radio :checked → one-time vs suscripción (data-radio-type)
            - <select.group_dropdown> → la frecuencia; cada <option> trae
              data-variant-price y data-variant-compare-at-price exactos.
          Mejor esfuerzo: si la app re-renderiza, se reaplica en el próximo
          change/click/timeout. ----- */
  function mirrorSubscriptionPrice(section) {
    if (!section) return;
    var card = getActiveSubCard(section);
    if (!card) return;
    var radio = card.querySelector('input[type="radio"]:checked');
    if (!radio) return;
    var isSub = radio.getAttribute('data-radio-type') === 'selling_plan_group';
    var group = radio.closest('.subscription_group');

    var priceText = null, comparePrice = '';
    if (isSub) {
      // La frecuencia elegida está en el <select>; su <option> trae el precio.
      var sel = card.querySelector('select.group_dropdown');
      var src = (sel && sel.options && sel.selectedIndex >= 0) ? sel.options[sel.selectedIndex] : radio;
      priceText = src.getAttribute('data-variant-price');
      comparePrice = src.getAttribute('data-variant-compare-at-price') || '';
    } else {
      priceText = radio.getAttribute('data-variant-price');
    }
    if (!priceText) return;

    // Precio visible del grupo elegido (el €11,35) → refleja la frecuencia.
    // Solo escribimos si cambia, para no disparar el MutationObserver en bucle.
    var widgetPrice = group ? group.querySelector('.in_widget_price') : null;
    if (widgetPrice && (widgetPrice.textContent || '').trim() !== priceText) {
      widgetPrice.textContent = priceText;
    }

    // Badge "Ahorra X€" ENCIMA del precio, solo si el ahorro >= SAVINGS_MIN €
    // (en 1 botella el ahorro es ~0,36€ y no compensa mostrarlo).
    var savingsNum = NaN;
    if (isSub && comparePrice) {
      var pv = parseMoneyNum(priceText), cv = parseMoneyNum(comparePrice);
      if (!isNaN(pv) && !isNaN(cv) && cv > pv) savingsNum = cv - pv;
    }
    var showBadge = !isNaN(savingsNum) && savingsNum >= SAVINGS_MIN;
    if (group) {
      // Badge montado SOBRE el borde superior del .subscription_group
      // (posicionado en absoluto por CSS; el grupo ya es position:relative).
      var badge = group.querySelector('[data-aceites-sub-savings]');
      if (showBadge) {
        if (!badge) {
          badge = document.createElement('span');
          badge.setAttribute('data-aceites-sub-savings', '');
          badge.className = 'aceites-sub-savings';
          group.appendChild(badge);
        }
        var txt = 'Ahorra ' + savingsNum.toFixed(2).replace('.', ',') + '€';
        if (badge.textContent !== txt) badge.textContent = txt;
      } else if (badge) {
        badge.remove();
      }
    }

    // Espejo opcional en el precio principal / sticky (si existen en el tema)
    var mainPrice = section.querySelector('.aceites-product__price');
    if (mainPrice && (mainPrice.textContent || '').trim() !== priceText) mainPrice.textContent = priceText;
    var stickyPrice = section.querySelector('[data-sticky-price]');
    if (stickyPrice && (stickyPrice.textContent || '').trim() !== priceText) stickyPrice.textContent = priceText;
    var savingsEl = section.querySelector('[data-price-savings]');
    if (savingsEl) { savingsEl.textContent = ''; savingsEl.hidden = true; }
  }

  /* ----- Engancha el espejo de precio a los cambios del app block de
          suscripciones (radios one-time/subscription y dropdown de frecuencia).
          Corre en rAF para dejar que la app actualice su .in_widget_price
          primero, y una vez al inicio para el estado inicial. ----- */
  function initSubscriptionPriceMirror() {
    $$('.aceites-product').forEach(function (section) {
      var appBlock = section.querySelector('.shopify_subscriptions_app_block');
      if (!appBlock) return;
      // Reaplica en varios frames/tiempos para dejar que la app sincronice su
      // estado interno (input selected-selling-plan-id) tras la interacción.
      var run = function () {
        requestAnimationFrame(function () {
          mirrorSubscriptionPrice(section);
          requestAnimationFrame(function () { mirrorSubscriptionPrice(section); });
        });
        setTimeout(function () { mirrorSubscriptionPrice(section); }, 120);
      };
      // change → radios / select nativo;  click → dropdown custom de frecuencia
      section.addEventListener('change', function (e) {
        if (e.target.closest('.shopify_subscriptions_app_block')) run();
      });
      section.addEventListener('click', function (e) {
        if (e.target.closest('.shopify_subscriptions_app_block')) run();
      });
      // Estado inicial (la app puede hidratar tras la carga)
      run();
      setTimeout(run, 600);

      // La app inyecta/re-renderiza el widget y sus perks de forma asíncrona;
      // observamos para reaplicar precio y ocultar perks cuando aparezcan.
      var obsRoot = section.querySelector('.aceites-product__info-col') || appBlock;
      var obs = new MutationObserver(function () {
        mirrorSubscriptionPrice(section);
      });
      obs.observe(obsRoot, { childList: true, subtree: true });
      setTimeout(function () { obs.disconnect(); }, 15000);
    });
  }

  /* ----- Helper: leer el plan id elegido en el bloque oficial de Shopify Subscriptions ----- */
  function readShopifySubscriptionPlan(section, variantId) {
    // Estrategia primaria: leer directo del radio checked dentro de la card
    // activa. Cada radio de suscripción tiene data-selling-plan-id; los de
    // compra única no. La app sincroniza este dataset con el dropdown de
    // frecuencia si corresponde, así que es la fuente de verdad.
    if (variantId) {
      var cards = section.querySelectorAll('.shopify_subscriptions_app_block[data-variant-id]');
      var vidStr = String(variantId);
      for (var i = 0; i < cards.length; i++) {
        var cid = cards[i].getAttribute('data-variant-id') || '';
        // Match exacto o con sufijo separador (mismo criterio que syncSubscriptionCards)
        if (cid === vidStr || cid.indexOf(vidStr + '_') === 0) {
          var radio = cards[i].querySelector('input[type="radio"][data-radio-type]:checked');
          var planId = radio && radio.dataset && radio.dataset.sellingPlanId;
          if (planId && planId !== 'null' && planId !== '') return planId;
          return '';
        }
      }
    }

    // Fallback: <input class="selected-selling-plan-id"> que la app inyecta
    // en los forms con action="/cart/add". Vale '' si es compra única.
    var inputs = section.querySelectorAll('.selected-selling-plan-id');
    for (var j = 0; j < inputs.length; j++) {
      var v = inputs[j].value;
      if (v && v !== 'null' && v !== '') return v;
    }
    return '';
  }

  /* ----- Add to cart AJAX (variant_selector + @app subscriptions + buy_form separados) ----- */
  function initAjaxAddToCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-button]');
      if (!btn) return;
      // Solo manejar los botones nuevos, no los que estén dentro de un <form>
      if (btn.closest('form')) return;

      e.preventDefault();
      if (btn.disabled) return;

      var section = btn.closest('.aceites-product');
      if (!section) return;

      var selector = section.querySelector('[data-variant-selector]');
      var variantSelect = selector ? selector.querySelector('[data-variant-select]') : null;
      var variantId = variantSelect ? variantSelect.value : null;
      if (!variantId) {
        console.warn('[add-to-cart] sin variant id');
        return;
      }

      var qtyInput = section.querySelector('[data-qty-input]');
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

      var formData = { id: variantId, quantity: qty };

      // Buscar selling_plan en el bloque de Shopify Subscriptions.
      // La app renderiza una "card" por variante, cada una con:
      //  - 2 radios name="purchaseOption_<section>_<variantId>" (one-time vs subscription)
      //  - 1 <select> sin name con los plan ids como options
      // Detectamos la card de la variante actual, comprobamos si está en
      // modo subscription y, si lo está, leemos el plan id del select.
      var sellingPlanValue = readShopifySubscriptionPlan(section, variantId);
      if (!sellingPlanValue) {
        // Fallback a otras apps de suscripciones que sí usan un input estándar
        var sellingPlanInput = section.querySelector('input[name="selling_plan"]:checked');
        if (sellingPlanInput && sellingPlanInput.value) {
          sellingPlanValue = sellingPlanInput.value;
        }
      }
      if (sellingPlanValue) {
        formData.selling_plan = sellingPlanValue;
      }

      // Propiedades line item: cualquier input name="properties[xxx]"
      var propertyInputs = section.querySelectorAll('[name^="properties["]');
      if (propertyInputs.length) {
        formData.properties = {};
        propertyInputs.forEach(function (p) {
          if (p.type === 'checkbox' && !p.checked) return;
          if (p.type === 'radio' && !p.checked) return;
          var match = p.name.match(/^properties\[(.+)\]$/);
          if (match) formData.properties[match[1]] = p.value;
        });
      }

      btn.classList.add('is-loading');
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(formData)
      })
        .then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          if (!res.ok) {
            console.warn('[add-to-cart] error', res.data);
            alert((res.data && res.data.description) || 'No se pudo añadir al carrito.');
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:added', { detail: res.data }));
          // Si existe un drawer/cart link, navegamos por defecto al carrito
          if (!document.querySelector('[data-cart-drawer]')) {
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          console.warn('[add-to-cart] fetch error', err);
        })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
    });
  }

  /* ----- Quantity buttons ----- */
  function initQty() {
    document.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-qty-decrease]');
      var inc = e.target.closest('[data-qty-increase]');
      if (!dec && !inc) return;
      var btn = dec || inc;
      var input = btn.parentElement.querySelector('[data-qty-input]');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      v = dec ? Math.max(1, v - 1) : v + 1;
      input.value = v;
    });
  }

  /* ----- Add-to-cart loading state (cart.js maneja el submit) ----- */
  function initAddState() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('[data-product-add]')) return;
      var btn = form.querySelector('[data-add-button], .aceites-product__upsell-btn, button[type="submit"]');
      if (!btn) return;
      btn.classList.add('is-loading');
      btn.disabled = true;
      setTimeout(function () { btn.classList.remove('is-loading'); btn.disabled = false; }, 1200);
    });
  }

  /* ----- Upsells: recomendaciones automáticas Shopify ----- */
  function initUpsells() {
    var blocks = $$('[data-upsells][data-source="auto"]');
    blocks.forEach(function (block) {
      var pid = block.dataset.productId;
      var limit = block.dataset.limit || '2';
      var url = '/recommendations/products?product_id=' + pid + '&limit=' + limit + '&intent=related&section_id=product-recommendations';
      fetch(url, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-upsells-list]');
          var target = block.querySelector('[data-upsells-list]');
          if (!target) return;
          if (fresh && fresh.innerHTML.trim() !== '') {
            target.innerHTML = fresh.innerHTML;
          } else {
            target.innerHTML = '';
            target.style.display = 'none';
            block.style.display = 'none';
          }
        })
        .catch(function (err) {
          console.warn('[upsells] recomendaciones no disponibles', err);
        });
    });
  }

  /* ----- Konvo: ocultar su launcher mientras la barra sticky está visible ----- */
  // El bubble de Konvo (Userlike) se inyecta en <body> con un z-index altísimo y se
  // pone por encima de la barra sticky de compra. Como vive fuera del contexto de
  // apilamiento de la sección, subir el z-index no basta: lo ocultamos por completo
  // mientras haya alguna barra sticky visible y lo restauramos al ocultarse. El
  // ocultado real lo hace una regla CSS (body.aceites-konvo-hidden ...) en main-product.scss.
  function syncKonvoHidden() {
    var anyStickyVisible = !!$('[data-sticky-bar].is-visible');
    document.body.classList.toggle('aceites-konvo-hidden', anyStickyVisible);
  }

  /* ----- Sticky add to cart ----- */
  function initStickyAddToCart() {
    var stickies = $$('[data-sticky-bar]');
    stickies.forEach(function (sticky) {
      var section = sticky.closest('.aceites-product');
      if (!section) return;

      var mainAddBtn = section.querySelector('.aceites-product__add');
      var footer = document.querySelector('.aceites-footer');
      var stickySelect = $('[data-sticky-variant-select]', sticky);
      var stickyText = $('[data-sticky-select-text]', sticky);
      var stickyBadge = $('[data-sticky-select-badge]', sticky);
      var stickyPrice = $('[data-sticky-price]', sticky);
      var stickyAddBtn = $('[data-sticky-add]', sticky);
      var variantSelector = section.querySelector('[data-variant-selector]');
      var mainVariantSelect = section.querySelector('[data-variant-select]');

      var mainBtnVisible = true;
      var footerVisible = false;

      function updateVisibility() {
        var shouldShow = !mainBtnVisible && !footerVisible;
        sticky.classList.toggle('is-visible', shouldShow);
        sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        syncKonvoHidden();
      }

      function updateDisplay() {
        if (!stickySelect) return;
        var opt = stickySelect.options[stickySelect.selectedIndex];
        if (!opt) return;
        var text = opt.getAttribute('data-text') || opt.textContent.trim();
        var disc = parseInt(opt.getAttribute('data-discount') || '0', 10);
        var price = opt.getAttribute('data-price');
        if (stickyText) stickyText.textContent = text;
        if (stickyBadge) {
          if (disc > 0) {
            stickyBadge.textContent = '-' + disc + '% OFF';
            stickyBadge.hidden = false;
          } else {
            stickyBadge.hidden = true;
          }
        }
        if (stickyPrice && price) stickyPrice.textContent = price;
        if (stickyAddBtn) stickyAddBtn.disabled = opt.disabled;
        syncCustomPanelSelected();
      }

      var combobox = sticky.querySelector('[data-sticky-combobox]');
      var trigger = sticky.querySelector('[data-sticky-select-trigger]');
      var panel = sticky.querySelector('[data-sticky-select-panel]');
      var options = panel ? $$('[role="option"]', panel) : [];

      function syncCustomPanelSelected() {
        if (!stickySelect || !options.length) return;
        var current = stickySelect.value;
        options.forEach(function (opt) {
          var isSel = opt.getAttribute('data-value') === current;
          opt.classList.toggle('is-selected', isSel);
          opt.setAttribute('aria-selected', isSel ? 'true' : 'false');
        });
      }

      function openPanel() {
        if (!panel || !trigger) return;
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        combobox.classList.add('is-open');
        var selected = panel.querySelector('.is-selected:not(.is-disabled)') || panel.querySelector('[role="option"]:not(.is-disabled)');
        if (selected) selected.focus();
      }

      function closePanel() {
        if (!panel || !trigger) return;
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        combobox.classList.remove('is-open');
      }

      function selectOption(opt) {
        if (!opt || opt.classList.contains('is-disabled') || !stickySelect) return;
        var value = opt.getAttribute('data-value');
        if (stickySelect.value !== value) {
          stickySelect.value = value;
          stickySelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        closePanel();
        if (trigger) trigger.focus();
      }

      if (trigger && panel) {
        trigger.addEventListener('click', function () {
          if (panel.hidden) openPanel(); else closePanel();
        });

        options.forEach(function (opt) {
          opt.setAttribute('tabindex', '-1');
          opt.addEventListener('click', function () { selectOption(opt); });
        });

        panel.addEventListener('keydown', function (e) {
          var focused = document.activeElement;
          var enabled = options.filter(function (o) { return !o.classList.contains('is-disabled'); });
          var idx = enabled.indexOf(focused);
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            var next = enabled[(idx + 1 + enabled.length) % enabled.length];
            if (next) next.focus();
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            var prev = enabled[(idx - 1 + enabled.length) % enabled.length];
            if (prev) prev.focus();
          } else if (e.key === 'Home') {
            e.preventDefault();
            if (enabled[0]) enabled[0].focus();
          } else if (e.key === 'End') {
            e.preventDefault();
            if (enabled[enabled.length - 1]) enabled[enabled.length - 1].focus();
          } else if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (focused && focused.getAttribute('role') === 'option') selectOption(focused);
          } else if (e.key === 'Escape') {
            e.preventDefault();
            closePanel();
            if (trigger) trigger.focus();
          } else if (e.key === 'Tab') {
            closePanel();
          }
        });

        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openPanel();
          }
        });

        document.addEventListener('click', function (e) {
          if (!combobox.contains(e.target) && !panel.hidden) closePanel();
        });
      }

      function syncFromSticky() {
        if (!stickySelect || !mainVariantSelect) return;
        var variantId = stickySelect.value;
        var opt = stickySelect.options[stickySelect.selectedIndex];

        if (variantSelector && opt) {
          var optionValues = [
            opt.getAttribute('data-option1'),
            opt.getAttribute('data-option2'),
            opt.getAttribute('data-option3')
          ];
          var lastChangedRadio = null;
          optionValues.forEach(function (val, idx) {
            if (!val) return;
            var fs = variantSelector.querySelector('fieldset[data-option-index="' + idx + '"]');
            if (!fs) return;
            var radios = $$('input[type="radio"]', fs);
            for (var i = 0; i < radios.length; i++) {
              if (radios[i].value === val) {
                if (!radios[i].checked) {
                  radios[i].checked = true;
                  lastChangedRadio = radios[i];
                }
                break;
              }
            }
          });
          if (lastChangedRadio) {
            lastChangedRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        if (mainVariantSelect.value !== variantId) {
          mainVariantSelect.value = variantId;
        }
        updateDisplay();
      }

      function syncFromMain() {
        if (!stickySelect || !mainVariantSelect) return;
        if (stickySelect.value !== mainVariantSelect.value) {
          stickySelect.value = mainVariantSelect.value;
        }
        updateDisplay();
      }

      if (stickySelect) {
        stickySelect.addEventListener('change', syncFromSticky);
      }

      if (variantSelector) {
        variantSelector.addEventListener('change', function () {
          setTimeout(syncFromMain, 0);
        });
      }

      if ('IntersectionObserver' in window) {
        if (mainAddBtn) {
          var btnObs = new IntersectionObserver(function (entries) {
            mainBtnVisible = entries[0].isIntersecting;
            updateVisibility();
          }, { threshold: 0, rootMargin: '0px 0px -120px 0px' });
          btnObs.observe(mainAddBtn);
        } else {
          mainBtnVisible = false;
        }

        if (footer) {
          var footObs = new IntersectionObserver(function (entries) {
            footerVisible = entries[0].isIntersecting;
            updateVisibility();
          }, { threshold: 0 });
          footObs.observe(footer);
        }
      }

      // Si el producto tiene suscripciones, el botón del sticky no debe
      // añadir al carrito directamente: hace scroll al bloque de info del
      // producto para que el usuario elija plan en el widget de suscripciones.
      var hasSubscriptions = !!section.querySelector('.shopify_subscriptions_app_block, [data-sub-message]');
      if (hasSubscriptions && stickyAddBtn) {
        stickyAddBtn.addEventListener('click', function (e) {
          if (stickyAddBtn.disabled) return;
          var target = section.querySelector('.aceites-product__info-col');
          if (!target) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, true);
      }

      updateDisplay();
      updateVisibility();
    });
  }

  /* ----- Reseñas manuales: rotador ----- */
  function initManualReviews() {
    var roots = $$('[data-manual-reviews]');
    roots.forEach(function (root) {
      var slides = $$('[data-mr-slide]', root);
      if (slides.length === 0) return;
      var i = 0;
      slides[0].classList.add('is-active');
      var nextBtn = $('[data-mr-next]', root);

      function show(idx) {
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
      }
      function advance() { i = (i + 1) % slides.length; show(i); }

      if (nextBtn) nextBtn.addEventListener('click', advance);
      if (slides.length > 1) {
        setInterval(advance, 7000);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGalleryMobile();
    initVariantSync();
    initQty();
    initAddState();
    initAjaxAddToCart();
    initUpsells();
    initManualReviews();
    initStickyAddToCart();
    initSubscriptionPriceMirror();
  });
})();
